import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, BaseRouteReuseStrategy } from '@angular/router';

/** Route `data` flag: rebuild the component when the route's params change. */
export const RECREATE_ON_PARAM_CHANGE = 'recreateOnParamChange';

/**
 * Angular keeps a component alive across a navigation that only changes its params — `edit-cart/A`
 * to `edit-cart/B` reuses the builder still holding cart A. A route that reads its params once
 * opts out with `data: { recreateOnParamChange: true }` and is built fresh for each id instead.
 */
@Injectable()
export class ParamRouteReuseStrategy extends BaseRouteReuseStrategy {
  override shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    if (!super.shouldReuseRoute(future, curr)) return false;
    if (future.routeConfig?.data?.[RECREATE_ON_PARAM_CHANGE] !== true) return true;
    return JSON.stringify(future.params) === JSON.stringify(curr.params);
  }
}
